import React, { useState, useEffect } from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { Spinner } from "../../atoms";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Grid from '@mui/material/Grid';
import { updateOperationalHours, getUserPreference } from "../../../api/api";
import { set } from "react-hook-form";
import { IconButton } from "@mui/material";
import { FaBackspace } from "react-icons/fa";
import { FaAngleDown } from "react-icons/fa";
import { FaAngleUp } from "react-icons/fa";
import { Toaster, toast } from "react-hot-toast";
import { useMediaQuery } from "react-responsive";

const OperationalHours = ({ handleSettingSwitch }) => {
  
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 900px)' })
 
  

  
  const [loading, setLoading] = useState(false);
  const [startTime, setStartTime] = useState("09:00");
  const [endTime, setEndTime] = useState("17:00");

  useEffect(async () => {
    
    setLoading(true);
     var response = await getUserPreference();
     
     if (response) 
     {
         console.log(response, response.data.operationalTimeStart, response.data.operationalTimeEnd);
        setStartTime(response.data.operationalTimeStart);
        setEndTime(response.data.operationalTimeEnd);
         
     }
   
     setLoading(false);
   }, []);
   const initialText =
    "This features enables you to set your preferred operating hours. This also determines the time window for courier pickups from FedEx, etc.";

  const [showFullText, setShowFullText] = useState(
    window.innerWidth > 768 // Show full text by default on larger screens
  );
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(
    window.innerWidth <= 768
  );

  const handleToggleText = () => {
    setShowFullText(!showFullText);
  };

  const handleResize = () => {
    const isMobileOrTabletNow = window.innerWidth <= 768;
    setIsMobileOrTablet(isMobileOrTabletNow);

    // Adjust showFullText based on screen size change
    if (isMobileOrTablet !== isMobileOrTabletNow) {
      setShowFullText(!isMobileOrTabletNow);
    }
  };

  
  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isMobileOrTablet]);


  const handleToggle = async () => {
    try {
      
      setLoading(true);
      console.log("start and end", startTime, endTime, typeof(endTime));
      const response = await updateOperationalHours(
        {            
            StartTime : startTime,
            EndTime: endTime
        }
      );

      if (response) {
        
      
          toast.success("Operational Hours Updated Successfully");
        
      } else {
        console.error("API call failed");
      }
    } catch (error) {
      console.error("Error making API call", error);
      toast.error("Could not complete request");
    } finally {
      setLoading(false);
    }
  };
  const handleStartTimeChange = (event) => {

    setStartTime(event.target.value);
  };

  
  const handleEndTimeChange = (event) => {
    console.log("loging",event.target.value);
    setEndTime(event.target.value);
  };

  const DisplaySpinner = () => {

    return (
      <div className="spinnerDiv">
        <Spinner color={"black"} loading={true} size={40} />
      </div>
    );
  };
  return (
    <div className="tabPanelCls h-100">
      <Toaster />
      <div
        className="dispatchTimer"
        style={{ position: "relative", marginTop: "20px" }}
      >
        <div
          style={{
            position: "fixed",
            width: "100%",
            background: "white",
            marginTop: "10px",
          }}
        >
          <div className="header">
            <div style={{ marginBottom: 20 }}>
              <h2 className="ruby center">
                <IconButton onClick={() => handleSettingSwitch("")}>
                  <FaBackspace />
                </IconButton>
                Update Operational Hours
              </h2>
            </div>
            <p style={{ maxWidth: "70vw" }}>
              {showFullText ? initialText : `${initialText.slice(0, 100)}... `}
              {isMobileOrTablet && (
                <span
                  style={{
                    color: "grey",
                    cursor: "pointer",
                    marginLeft: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                    marginTop: 5,
                  }}
                  onClick={handleToggleText}
                >
                  {showFullText ? "Read less" : "Read more"}
                  {showFullText ? <FaAngleUp /> : <FaAngleDown />}
                </span>
              )}
            </p>
          </div>
          
          <div style={{position:'fixed', width: isTabletOrMobile ? "90%" : "50%"}}>
          {loading ? (
          <div
                                style={{
                                position: 'relative',
                                top: 0,
                                left: 0,
                                width: '100%',
                                
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'rgba(255, 255, 255, 0.8)', 
                                zIndex: 0,
                                }}
                            >
                        <DisplaySpinner />
                        
                        </div>
                        ) : (
                            <Paper className="padding2 space-top">
          
                            <Grid container spacing={2} style={{}}>
                              <Grid item xs={6} sm={6} md={6} >
                                <TextField
                                  id="start-time"
                                  label="Opening Time"
                                  type="time"
                                  value={startTime}
                                  onChange={handleStartTimeChange}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  inputProps={{
                                    step: 300, // 5 min
                                  }}
                                  fullWidth
                                />
                              </Grid>
                              <Grid item xs={6} sm={6} md={6} >
                                <TextField
                                  id="end-time"
                                  label="Closing Time"
                                  type="time"
                                  value={endTime}
                                  onChange={handleEndTimeChange}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  inputProps={{
                                    step: 300, // 5 min
                                  }}
                                  fullWidth
                                />
                              </Grid>
                            </Grid>
                            
                            <div className="push-right space-top2">
                                                          <Stack direction={"row"} spacing={2}>
                                                              <Button variant="contained" sx={{ background: "#4E9D24" }} onClick={handleToggle}>Save Operational Hours</Button>
                                                              {/* <Button variant="contained" sx={{ background: "#000" }}>Cancel</Button> */}
                                                          </Stack>
                      
                                                      </div>
                          </Paper>
                        )}
          
            </div>
        </div>
      </div>
    </div>
  );
};

export default OperationalHours;
